export enum HealthStatus {
  Healthy = "healthy",
  Unhealthy = "unhealthy",
}
